<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hand" class="d-icon d-icon--hand" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.226.559a1.438 1.438 0 0 1 1.133.555l.01.014c.036.047.07.096.099.147l.011-.006c.05-.03.102-.058.156-.082l.012-.006a1.44 1.44 0 0 1 .172-.064l.041-.01c.048-.012.095-.022.144-.03l.021-.004.059-.008a1.45 1.45 0 0 1 .143-.006l.141.006a1.439 1.439 0 0 1 .961.51l.018.023.045.06c.114.16.195.34.237.53a1.437 1.437 0 0 1 2.034 1.308v3.5a4.437 4.437 0 0 1-4.437 4.438h-1c-1.518 0-2.478-.478-3.303-1.297l-.003-.003L.724 7.918a1.438 1.438 0 0 1 1.914-2.13l.105.088.016.015.031.03.003-1c.002-.45.002-1.054 0-1.548 0-.247-.002-.465-.003-.622v-.186l-.002-.05v-.019a1.439 1.439 0 0 1 2.195-1.22c.03-.052.062-.1.098-.148l.01-.014A1.439 1.439 0 0 1 6.226.558Zm0 .875a.563.563 0 0 0-.563.562v.5l.001 2.747a.438.438 0 0 1-.875 0V2.496a.562.562 0 1 0-1.126 0v.015l.001.05.001.185.003.624c.002.494.002 1.103 0 1.556-.003.506-.003 1.02-.004 1.406v.647a.438.438 0 0 1-.748.31l-.766-.77a.563.563 0 0 0-.795.793L3.54 9.517c.665.66 1.404 1.043 2.687 1.043h1a3.564 3.564 0 0 0 3.562-3.563v-3.5a.562.562 0 0 0-1.124-.01v2.01a.438.438 0 0 1-.875 0v-3a.563.563 0 0 0-1.125 0v2.5a.438.438 0 0 1-.875 0v-3a.562.562 0 0 0-.563-.562Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHand',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
